import React, { useState, useEffect, useCallback, useRef } from "react";
import "./../../App.css";
import "./Payroll.css";
import "react-tabs/style/react-tabs.css";
import { CreateTable, CreateTableForEmployeeSelect } from "../ManageTable";
import { CreateButton, CreateSearchBarWithPlaceHolder } from "../CommonObjects";
import {
  SetAuditTrail,
  SetAuditTrailBulk,
} from "./../Reports/AuditTrailReportEmployeeSetup";
import { token, domain } from "../Security";
import axios from '../../api/apiClient';
import { useTable } from "react-table";
import loadingSpinner from "./../../assets/loading.gif";
import { format } from "date-fns";
import * as XLSX from "xlsx"; // Import all exports from xlsx library
// icons
import SettingsIcon from "@mui/icons-material/Settings";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DownloadIcon from "@mui/icons-material/Download";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CloseIcon from "@mui/icons-material/Close";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import PaidIcon from "@mui/icons-material/Paid";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

function Agency({ user, userAccess, isHideSideMenu }) {
  const [showSetting, setShowSetting] = useState(false);
  const settingRef = useRef(null);
  const buttonRef = useRef(null);
  const [settingType, setSettingType] = useState("");

  const handleSetting = () => {
    setShowSetting(!showSetting);
  };

  useEffect(() => {
    var settingIcon = document.getElementById("setting-icon");

    if (showSetting) {
      //change the down icon to up
      settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
      settingIcon.children[0].setAttribute(
        "d",
        `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`
      ); // Up Arrow.Path d attribute
    } else {
      //change the up icon to down
      settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
      settingIcon.children[0].setAttribute(
        "d",
        `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`
      ); // Down Arrow.Path d attribute
    }

    const handleClickOutside = (event) => {
      if (settingRef.current && !settingRef.current.contains(event.target)) {
        if (buttonRef.current && !buttonRef.current.contains(event.target)) {
          setShowSetting(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSetting]);

  const [loadingRequest, setLoadingRequest] = useState(false);

  const [payrollData, setPayrollData] = useState([]);
  const [payrollDataAdjustment, setPayrollDataAdjustment] = useState([]);

  const [otherAdditionData, setOtherAdditionData] = useState([]);
  const [otherDeductionData, setOtherDeductionData] = useState([]);
  //filters
  const [filterPayrollPeriodId, setFilterPayrollPeriodId] = useState("");
  const [filterPayTypeId, setFilterPayTypeId] = useState("");
  const [isGenerate, setIsGenerate] = useState(false);
  const [generateMessage, setGenerateMessage] = useState(false);

  const [showUploadForm, setShowUploadForm] = useState(false);
  const [payrollIdForUpload, setPayrollIdForUpload] = useState("");
  const [payTypeIdForUpload, setPayTypeIdForUpload] = useState("");
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }

    if (generateMessage) {
      const timeoutId = setTimeout(() => {
        setGenerateMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [generateMessage, showRequestMessage]);

  const [type, setType] = useState(0);

  // =============================================================
  // ===================ADJUSTMENTS===============================
  // =============================================================
  const [loadingOtherAddition, setLoadingOtherAddition] = useState(false);
  const [loadingOtherDedujction, setLoadingOtherDedujction] = useState(false);
  const [filterDataAddition, setFilterDataAddition] = useState([]);
  const [filterDataDeduction, setFilterDataDeduction] = useState([]);

  const fetchAdditionData = useCallback(async () => {
    const apiUrl = domain + "/api/";
    if (!isGenerate) return;

    if (!filterPayTypeId || !filterPayrollPeriodId) {
      return;
    }
    try {
      setLoadingOtherAddition(true);
      const response = await axios.get(
        apiUrl +
          `AgencyOtherAddition/payroll-period/${filterPayrollPeriodId}/pay-type/${filterPayTypeId}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );
      setOtherAdditionData(response.data); // Set the response data to the state
      setFilterDataAddition(response.data); // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingOtherAddition(false);
    }
  }, [
    isGenerate,
    filterPayTypeId,
    filterPayrollPeriodId,
    setOtherAdditionData,
  ]);
  const fetchDeductionData = useCallback(async () => {
    const apiUrl = domain + "/api/";
    if (!isGenerate) return;

    if (!filterPayTypeId || !filterPayrollPeriodId) {
      return;
    }
    try {
      setLoadingOtherDedujction(true);
      const response = await axios.get(
        apiUrl +
          `AgencyOtherDeduction/payroll-period/${filterPayrollPeriodId}/pay-type/${filterPayTypeId}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );
      setOtherDeductionData(response.data); // Set the response data to the state
      setFilterDataDeduction(response.data); // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingOtherDedujction(false);
    }
  }, [
    isGenerate,
    filterPayTypeId,
    filterPayrollPeriodId,
    setOtherDeductionData,
  ]);
  // =============================================================
  // ===================ADJUSTMENTS===============================
  // =============================================================

  const fetchAllIdsData = useCallback(async () => {
    const apiUrl = domain + "/api/Employee/basic-info/all";
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });

      const ids = response.data.map((employee) => employee.employeeId);
      return ids;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, []);

  const fetchEmployeeByEmployeeId = useCallback(async (_employeeId) => {
    const apiUrl = domain + "/api/Employee/employeeid";
    try {
      const response = await axios.get(`${apiUrl}/${_employeeId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, []);

  const handleGenerate = async () => {
    if (!filterPayrollPeriodId || !filterPayTypeId) {
      setGenerateMessage(true);
      return;
    }

    setIsGenerate(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchAdditionData();
      await fetchDeductionData();
    };

    if (isGenerate) {
      fetchData();
      // setIsGenerate(false);
    }
  }, [isGenerate, fetchAdditionData, fetchDeductionData]);

  const generateDownloadTemplate = (isAdjustment) => {
    const data = [
      ["EmployeeId", "EmployeeName", "Description", "Amount"],
      ["<EMP1234>", "<LastName, FirstName>", "<Description>", "<500.00>"],
    ];
    const dataAdjustment = [
      [
        "EmployeeId",
        "EmployeeName",
        "Description",
        "Amount",
        "NumberOfHours",
        "AdjustmentDate",
        "ReferenceId",
      ],
      [
        "<EMP1234>",
        "<LastName, FirstName>",
        "<Description>",
        "<500.00>",
        "<8.00>",
        "<mm/dd/yyyy>",
        "<REF00001>",
      ],
    ];

    const workbook = XLSX.utils.book_new();

    const worksheet = XLSX.utils.aoa_to_sheet(
      isAdjustment ? dataAdjustment : data
    );

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const excelBuffer = XLSX.write(workbook, {
      type: "binary",
      bookType: "xlsx",
    });

    const blob = new Blob([s2ab(excelBuffer)], {
      type: "application/octet-stream",
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.download = "Template.xlsx";
    a.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  //For Upload Part
  const [errorData, setErrorData] = useState([]);
  const [isErrorUpload, setIsErrorUpload] = useState(false);
  const downloadError = useCallback((entries) => {
    const allData = [];

    entries.forEach((entry) => {
      const data = [
        [
          entry.employeeId,
          entry.employeeName,
          entry.description,
          entry.amount,
          entry.error,
        ],
      ];

      allData.push(...data);
    });

    allData.unshift([
      "EmployeeId",
      "EmployeeName",
      "Description",
      "Amount",
      "Error(NOTE: Please delete this column if you want to re-use this worksheet)",
    ]);

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(allData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "RegularDataSheet");

    const excelBuffer = XLSX.write(workbook, {
      type: "binary",
      bookType: "xlsx",
    });

    const blob = new Blob([s2ab(excelBuffer)], {
      type: "application/octet-stream",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.download = "ErrorFile.xlsx";
    a.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }, []);
  const downloadErrorAdjustment = useCallback((entries) => {
    const allData = [];

    entries.forEach((entry) => {
      const data = [
        [
          entry.employeeId,
          entry.employeeName,
          entry.description,
          entry.amount,
          entry.adjustmentDate,
          entry.referenceId,
          entry.error,
        ],
      ];

      allData.push(...data);
    });

    allData.unshift([
      "EmployeeId",
      "EmployeeName",
      "Description",
      "Amount",
      "AdjusmentDate",
      "ReferenceId",
      "Error(NOTE: Please delete this column if you want to re-use this worksheet)",
    ]);

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(allData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "RegularDataSheet");

    const excelBuffer = XLSX.write(workbook, {
      type: "binary",
      bookType: "xlsx",
    });

    const blob = new Blob([s2ab(excelBuffer)], {
      type: "application/octet-stream",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.download = "ErrorFile.xlsx";
    a.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }, []);
  function parseExcelFile(file, type) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const binaryString = e.target.result;
          const workbook = XLSX.read(binaryString, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];

          // Get all rows except the first one (header row)
          const excelData = XLSX.utils.sheet_to_json(sheet, {
            header:
              type === "Other Adjustments"
                ? [
                    "employeeId",
                    "employeeName",
                    "description",
                    "amount",
                    "noOfHours",
                    "adjustmentDate",
                    "referenceId",
                  ]
                : ["employeeId", "employeeName", "description", "amount"],
            range: 1, // Skip the first row (header row)
            defval: "", // Include empty cells
          });

          resolve(excelData);
        } catch (error) {
          reject(error);
        }
      };

      reader.readAsArrayBuffer(file);
    });
  }
  const handleFileUpload = async (files, type, payrollPeriodId, payTypeId) => {
    if (!files || files.length === 0) {
      console.error("No files selected");
      return;
    }

    setLoadingRequest(true);

    const employeeIds = await fetchAllIdsData();
    let finalData = [];

    const file = files[0];
    var apiUrl = "";
    if (type === "Other Additions") {
      apiUrl = domain + "/api/AgencyOtherAddition/bulk";
    } else if (type === "Other Deductions") {
      apiUrl = domain + "/api/AgencyOtherDeduction/bulk";
    }

    parseExcelFile(file, type)
      .then(async (data) => {
        let isError = false;

        data.forEach((entry) => {
          let errorMsg = "";

          for (let i = 0; i < Object.keys(entry).length; i++) {
            const header = Object.keys(entry)[i];
            const values = Object.values(entry)[i];
            if (values === null || values === undefined || values === "") {
              errorMsg = "Has an empty value. ";
              setIsErrorUpload(true);
              isError = true;
            }

            if (header === "employeeId") {
              const foundEmployee = employeeIds.find(
                (employee) => employee === values.toString()
              );
              if (!foundEmployee) {
                errorMsg = errorMsg + "Invalid employee id. ";
                setIsErrorUpload(true);
                isError = true;
              }
            }

            if (header === "amount") {
              if (isNaN(values)) {
                errorMsg = errorMsg + "Amount is an invalid value. ";
                setIsErrorUpload(true);
                isError = true;
              }
            }

            if (type === "Other Adjustments") {
              if (header === "noOfHours") {
                if (isNaN(values)) {
                  errorMsg = errorMsg + "Number of hours is an invalid value. ";
                  setIsErrorUpload(true);
                  isError = true;
                }
              }

              if (header === "adjustmentDate") {
                if (isNaN(values)) {
                  errorMsg = errorMsg + "Invalid adjustment date. ";
                  setIsErrorUpload(true);
                  isError = true;
                }
              }

              if (header === "referenceId") {
                if (isNaN(values)) {
                  errorMsg = errorMsg + "Invalid reference id. ";
                  setIsErrorUpload(true);
                  isError = true;
                }
              }
            }
          }

          const newErrorData = {
            employeeId: entry.employeeId,
            employeeName: entry.employeeName,
            description: entry.description,
            amount: entry.amount,
            ...(type === "Other Adjustments" && {
              adjustmentDate: entry.adjustmentDate,
            }),
            ...(type === "Other Adjustments" && {
              referenceId: entry.referenceId,
            }),
            error: errorMsg,
          };

          setErrorData((prevErrorData) => [...prevErrorData, newErrorData]);
        });

        if (isError) {
          return;
        }

        for (const entry of data) {
          const employeeInfoByEmployeeId = await fetchEmployeeByEmployeeId(
            entry.employeeId
          );

          const _data = {
            employeePersonalInformationId: employeeInfoByEmployeeId.id,
            payrollPeriodId: parseInt(payrollPeriodId),
            payTypeId: parseInt(payTypeId),
            description: entry.description,
            amount: parseInt(entry.amount),
          };

          finalData.push(_data);
        }

        console.log("Final bulkData:", JSON.stringify(finalData, null, 2));

        try {
          axios.post(apiUrl, finalData, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });
          let field = "";

          if (type === "Other Additions") {
            field = "Upload Other Additions";
          } else if (type === "Other Deductions") {
            field = "Upload Other Deductions";
          } else if (type === "Other Adjustments") {
            field = "Upload Other Adjustments";
          }

          await SetAuditTrail({
            setupArea: "Agency",
            actionTaken: "insert",
            field: field,
            newValue: "[bulk data]",
            oldValue: "-",
            dateSaved: new Date(),
            savedById: user.id,
          });
          await fetchAdditionData();
          await fetchDeductionData();

          setShowRequestMessage(true);
          setIsSuccess(true);
          setIsErrorUpload(false);
          setErrorData([]);
        } catch (error) {
          console.error("Error parsing Excel file:", error);
          setShowRequestMessage(true);
          setIsSuccess(false);

          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            const errorMessage = error.response.data.errors["$"][0]; // Accessing the error message
            setRequestMessage(errorMessage);
          } else if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            const errorMessage = error.response.data.message; // Fallback to general message
            setRequestMessage(errorMessage);
          } else {
            setRequestMessage("An unknown error occurred."); // Default message
          }
        }
      })
      .catch((error) => {
        setLoadingRequest(false);
        console.error("Error parsing Excel file:", error);
        setShowRequestMessage(true);
        setIsSuccess(false);
        const errorMessage = JSON.parse(
          error.response.request.responseText
        ).message;
        setRequestMessage(errorMessage);
      });

    setLoadingRequest(false);
  };

  useEffect(() => {
    if (isErrorUpload) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("Please check the ErrorFile.xlsx");
      setIsErrorUpload(false);
      setErrorData([]);

      if (settingType === "Other Adjustments") {
        downloadErrorAdjustment(errorData);
      } else {
        downloadError(errorData);
      }
    }
  }, [
    isErrorUpload,
    downloadError,
    downloadErrorAdjustment,
    errorData,
    settingType,
  ]);

  const openUploadFormHandleClick = () => {
    setShowUploadForm(true);
  };
  const closeUploadFormHandleClick = () => {
    setShowUploadForm(false);
  };

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="PayrollInfo shadow-xl">
            <div className="sub-title row" style={{ padding: "5px 20px" }}>
              <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>
                {"Payroll >"}{" "}
              </span>
              <span style={{ borderBottom: "1px solid black" }}>
                {"Agency"}
              </span>
            </div>
            <div className="payrollHeader row">
              <div
                style={{ width: "70%", color: "#668fca" }}
                className="payroll-title row"
              >
                <PaidIcon style={{ padding: "0 10px 0 0" }} />
                <h3>Agency</h3>
              </div>
              <div style={{ width: "30%", textAlign: "right" }}>
                <button
                  ref={buttonRef}
                  onClick={handleSetting}
                  title="Setting"
                  type="button"
                  className="setting"
                >
                  <SettingsIcon />
                  <KeyboardArrowDownIcon id="setting-icon" />
                </button>
                <div ref={settingRef}>
                  {showSetting && (
                    <SettingInit
                      generateDownloadTemplate={generateDownloadTemplate}
                      openUploadFormHandleClick={openUploadFormHandleClick}
                      setSettingType={setSettingType}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="payroll-body">
              <div style={{ padding: "10px" }}>
                <div className="filters-payroll">
                  <span>Filter</span>
                  <div
                    className="payroll-item-holder info-item-holder row"
                    style={{
                      justifyContent: "space-evenly",
                      padding: "0 10px 20px 10px",
                    }}
                  >
                    <div className="filter-item-payroll popUp-item info-item column">
                      <div className="info-item-label">Payroll Period</div>
                      <div className="info-item-input">
                        <PayrollPeriodIdSelect
                          payrollPeriodId={filterPayrollPeriodId}
                          setPayrollPeriodId={setFilterPayrollPeriodId}
                        />
                      </div>
                    </div>
                    <div className="filter-item-payroll popUp-item info-item column">
                      <div className="info-item-label">Pay Type</div>
                      <div className="info-item-input">
                        <PayTypeIdSelect
                          payTypeId={filterPayTypeId}
                          setPayTypeId={setFilterPayTypeId}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="rightSide-btn" style={{ marginRight: "5px" }}>
                    {CreateButton(
                      "",
                      "generate row",
                      handleGenerate,
                      "GENERATE",
                      RestartAltIcon
                    )}
                  </div>
                </div>
              </div>
              <ShowTab
                type={type}
                setType={setType}
                filterPayrollPeriodId={filterPayrollPeriodId}
                filterPayTypeId={filterPayTypeId}
                userAccess={userAccess}
                payrollData={payrollData}
                setPayrollData={setPayrollData}
                payrollDataAdjustment={payrollDataAdjustment}
                setPayrollDataAdjustment={setPayrollDataAdjustment}
                otherAdditionData={otherAdditionData}
                otherDeductionData={otherDeductionData}
                setOtherAdditionData={setOtherAdditionData}
                setOtherDeductionData={setOtherDeductionData}
                isGenerate={isGenerate}
                setIsGenerate={setIsGenerate}
                loadingOtherAddition={loadingOtherAddition}
                loadingOtherDedujction={loadingOtherDedujction}
                filterDataAddition={filterDataAddition}
                filterDataDeduction={filterDataDeduction}
                fetchAdditionData={fetchAdditionData}
                fetchDeductionData={fetchDeductionData}
                user={user}
              />
            </div>
          </div>
        </div>
      </div>
      <UploadForm
        isOpen={showUploadForm}
        onClose={closeUploadFormHandleClick}
        payrollPeriodId={payrollIdForUpload}
        payTypeId={payTypeIdForUpload}
        setPayrollPeriodId={setPayrollIdForUpload}
        setPayTypeId={setPayTypeIdForUpload}
        type={settingType}
        handleFileUpload={handleFileUpload}
      ></UploadForm>
      <GenerateMessage
        form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      ></GenerateMessage>
      <GenerateMessage
        form={generateMessage}
        message={"Please select payroll period, and pay type!"}
        isSuccess={false}
      ></GenerateMessage>
      {loadingRequest ? (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: "3005",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

function ShowTab({
  setFetch,
  type,
  setType,
  filterPayrollPeriodId,
  filterPayTypeId,
  filterClassificationId,
  filterClassificationId2,
  filterClassificationId3,
  userAccess,
  payrollData,
  setPayrollData,
  payrollDataAdjustment,
  setPayrollDataAdjustment,
  otherAdditionData,
  otherDeductionData,
  otherAdjustmentData,
  setOtherAdditionData,
  setOtherDeductionData,
  setOtherAdjustmentData,
  showPostMessage,
  setFetchForAddition,
  setFetchForDeduction,
  setFetchForAdjustment,
  setFetchForProcessed,
  isGenerate,
  setIsGenerate,

  loading,
  fetchData,
  filterData,
  loadingOtherAddition,
  loadingOtherDedujction,
  loadingAdjustment,
  filterDataAddition,
  filterDataDeduction,
  filterDataAdjustment,
  fetchAdditionData,
  fetchDeductionData,
  user,
}) {
  return (
    <div>
      <div className="payrollTab">
        <div>
          <ShowAdjustmentButtons
            otherAdditionData={otherAdditionData}
            otherDeductionData={otherDeductionData}
            otherAdjustmentData={otherAdjustmentData}
            setOtherAdditionData={setOtherAdditionData}
            setOtherDeductionData={setOtherDeductionData}
            setOtherAdjustmentData={setOtherAdjustmentData}
            payrollData={payrollDataAdjustment}
            setPayrollData={setPayrollDataAdjustment}
            filterPayrollPeriodId={filterPayrollPeriodId}
            filterPayTypeId={filterPayTypeId}
            filterClassificationId={filterClassificationId}
            filterClassificationId2={filterClassificationId2}
            filterClassificationId3={filterClassificationId3}
            userAccess={userAccess}
            setFetch={setFetch}
            type={type}
            showPostMessage={showPostMessage}
            setFetchForAddition={setFetchForAddition}
            setFetchForDeduction={setFetchForDeduction}
            setFetchForAdjustment={setFetchForAdjustment}
            isGenerate={isGenerate}
            setIsGenerate={setIsGenerate}
            loadingOtherAddition={loadingOtherAddition}
            loadingOtherDedujction={loadingOtherDedujction}
            loadingAdjustment={loadingAdjustment}
            filterDataAddition={filterDataAddition}
            filterDataDeduction={filterDataDeduction}
            filterDataAdjustment={filterDataAdjustment}
            fetchAdditionData={fetchAdditionData}
            fetchDeductionData={fetchDeductionData}
            user={user}
          />
        </div>
      </div>
    </div>
  );
}
function ShowAdjustmentButtons({
  payrollData,
  setPayrollData,
  otherAdditionData,
  otherDeductionData,
  otherAdjustmentData,
  setOtherAdditionData,
  setOtherDeductionData,
  setOtherAdjustmentData,
  filterPayrollPeriodId,
  filterPayTypeId,
  filterClassificationId,
  filterClassificationId2,
  filterClassificationId3,
  userAccess,
  setFetch,
  type,
  showPostMessage,
  setFetchForAddition,
  setFetchForDeduction,
  setFetchForAdjustment,
  isGenerate,
  setIsGenerate,

  loadingOtherAddition,
  loadingOtherDedujction,
  loadingAdjustment,
  filterDataAddition,
  filterDataDeduction,
  filterDataAdjustment,
  fetchAdditionData,
  fetchDeductionData,
  user,
}) {
  var adjustmentsHeader = ["Id", "Name", "Description", "Amount", ""];
  var adjustmentsAccesor = [
    "id",
    "employeePersonalInformationFullName",
    "description",
    "amount",
    "manage",
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const [loadingRequest, setLoadingRequest] = useState(false);
  //Add
  const [showAddForm, setShowAddForm] = useState(false);
  const [employeePersonalInformationId, setEmployeePersonalInformationId] =
    useState("");
  const [
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
  ] = useState("");
  const [payrollPeriodId, setPayrollPeriodId] = useState("");
  const [payTypeId, setPayTypeId] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [noOfHours, setNoOfHours] = useState("");
  const [adjustmentDate, setAdjustmentDate] = useState("");
  const [referenceId, setReferenceId] = useState("");
  //Old
  const [
    oldEmployeePersonalInformationId,
    setOldEmployeePersonalInformationId,
  ] = useState("");
  const [oldPayrollPeriodId, setOldPayrollPeriodId] = useState("");
  const [oldPayTypeId, setOldPayTypeId] = useState("");
  const [oldDescription, setOldDescription] = useState("");
  const [oldAmount, setOldAmount] = useState("");
  const [oldAdjustmentDate, setOldAdjustmentDate] = useState("");
  const [oldReferenceId, setOldReferenceId] = useState("");
  //Update
  const [showEditForm, setShowEditForm] = useState(false);
  const [editById, setEditById] = useState("");
  const [dataToEdit, setDataToEdit] = useState([]);
  // Delete
  const [showDeleteForm, setShowDeleteForm] = useState(false);
  const [deleteById, setDeleteById] = useState([]);
  const [deleteData, setDeleteData] = useState([]);
  // Delete All
  const [showDeleteAllForm, setShowDeleteAllForm] = useState(false);
  const [payrollIdForDelete, setPayrollIdForDelete] = useState("");

  const [showEmployeeForm, setShowEmployeeForm] = useState(false);
  const [referenceIdForm, setReferenceIdForm] = useState(false);
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);

  const apiUrl = domain + "/api/";

  const [adjustmentType, setAdjustmentType] = useState("AgencyOtherAddition");
  const [activeButton, setActiveButton] = useState("btn-tab-addition");

  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];
    if (adjustmentType === "AgencyOtherAddition") {
      res = filterDataAddition.filter((f) =>
        f.employeePersonalInformationFullName
          .toLowerCase()
          .includes(lowercaseValue)
      );

      setOtherAdditionData(res);
    } else if (adjustmentType === "AgencyOtherDeduction") {
      res = filterDataDeduction.filter((f) =>
        f.employeePersonalInformationFullName
          .toLowerCase()
          .includes(lowercaseValue)
      );

      setOtherDeductionData(res);
    } else {
      res = filterDataAdjustment.filter((f) =>
        f.employeePersonalInformationFullName
          .toLowerCase()
          .includes(lowercaseValue)
      );

      setOtherAdjustmentData(res);
    }
  };
  const handleClick = (id) => {
    if (id === "btn-tab-addition") {
      setAdjustmentType("AgencyOtherAddition");
    } else if (id === "btn-tab-deductions") {
      setAdjustmentType("AgencyOtherDeduction");
    }
    setActiveButton(id);
    handleOtherFunction(id);
  };
  const handleOtherFunction = (id) => {
    const additionTable = document.getElementById("addition-table");
    const deductionTable = document.getElementById("deduction-table");

    switch (id) {
      case "btn-tab-addition":
        additionTable.style.display = "block";
        deductionTable.style.display = "none";
        break;
      case "btn-tab-deductions":
        additionTable.style.display = "none";
        deductionTable.style.display = "block";
        break;
      case "btn-tab-adjustments":
        additionTable.style.display = "none";
        deductionTable.style.display = "none";
        break;
      default:
        break;
    }
  };
  const handleGenerate = useCallback(async () => {
    await fetchAdditionData();
    await fetchDeductionData();
  }, [fetchAdditionData, fetchDeductionData]);

  useEffect(() => {
    fetchAdditionData();
    fetchDeductionData();
  }, [
    type,
    handleGenerate,
    showPostMessage,
    fetchAdditionData,
    fetchDeductionData,
    isGenerate,
  ]);
  useEffect(() => {
    if (showEditForm) {
      setEmployeePersonalInformationId(
        dataToEdit.employeePersonalInformationId
      );
      setEmployeePersonalInformationFullName(
        dataToEdit.employeePersonalInformationFullName
      );
      setPayrollPeriodId(dataToEdit.payrollPeriodId);
      setPayTypeId(dataToEdit.payTypeId);
      setDescription(dataToEdit.description);
      setAmount(dataToEdit.amount);
      setAdjustmentDate(dataToEdit.adjustmentDate);
      setReferenceId(dataToEdit.referenceId);

      setOldEmployeePersonalInformationId(
        dataToEdit.employeePersonalInformationId
      );
      setOldPayrollPeriodId(dataToEdit.payrollPeriodId);
      setOldPayTypeId(dataToEdit.payTypeId);
      setOldDescription(dataToEdit.description);
      setOldAmount(dataToEdit.amount);
      setOldAdjustmentDate(dataToEdit.adjustmentDate);
      setOldReferenceId(dataToEdit.referenceId);
    }
  }, [showEditForm, dataToEdit]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const data = {
      employeePersonalInformationId: employeePersonalInformationId,
      payrollPeriodId: payrollPeriodId,
      payTypeId: payTypeId,
      description: description,
      amount: amount,
    };

    console.log("Final bulkData:", JSON.stringify(data, null, 2));
    console.log(apiUrl + `${adjustmentType}`);

    // ...(adjustmentType !== "OtherAdjustmentStaging" ? { amount: amount } : {})

    try {
      setLoadingRequest(true);
      const response = await axios.post(apiUrl + `${adjustmentType}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      let field = "";

      if (adjustmentType === "OtherAdditionStaging") {
        field = "Other Addition Add";
      } else if (adjustmentType === "OtherDeductionStaging") {
        field = "Other Deduction Add";
      }

      await SetAuditTrail({
        setupArea: "Agency",
        actionTaken: "insert",
        field: field,
        newValue: `${response.data.description}`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id,
      });
      await fetchAdditionData();
      await fetchDeductionData();

      console.log("Data added successfully");
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset form fields
      setEmployeePersonalInformationId("");
      setPayrollPeriodId("");
      setPayTypeId("");
      setDescription("");
      setAmount("");
      setShowAddForm(false); // Hide the add form
      // fetchData(adjustmentType);
    } catch (error) {
      console.error("There was a problem adding data:", error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowAddForm(false);
  };
  const handleUpdate = async (event) => {
    event.preventDefault();

    const data = {
      employeePersonalInformationId: employeePersonalInformationId,
      payrollPeriodId: payrollPeriodId,
      payTypeId: payTypeId,
      description: description,
      amount: amount,
    };

    try {
      setLoadingRequest(true);
      await axios.put(apiUrl + `${adjustmentType}/${editById}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      let field = "";

      if (adjustmentType === "OtherAdditionStaging") {
        field = "Other Addition Update";
      } else if (adjustmentType === "OtherDeductionStaging") {
        field = "Other Deduction Update";
      } else if (adjustmentType === "OtherAdjustmentStaging") {
        field = "Other Adjustment Update";
      }

      let auditInfo = [];

      if (
        data.employeePersonalInformationId !== oldEmployeePersonalInformationId
      ) {
        auditInfo.push({
          setupArea: "Agency",
          actionTaken: "update",
          field: field,
          newValue: `${data.employeePersonalInformationId}`,
          oldValue: `${oldEmployeePersonalInformationId}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.payrollPeriodId !== oldPayrollPeriodId) {
        auditInfo.push({
          setupArea: "Agency",
          actionTaken: "update",
          field: field,
          newValue: `${data.payrollPeriodId}`,
          oldValue: `${oldPayrollPeriodId}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.payTypeId !== oldPayTypeId) {
        auditInfo.push({
          setupArea: "Agency",
          actionTaken: "update",
          field: field,
          newValue: `${data.payTypeId}`,
          oldValue: `${oldPayTypeId}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.description !== oldDescription) {
        auditInfo.push({
          setupArea: "Agency",
          actionTaken: "update",
          field: field,
          newValue: `${data.description}`,
          oldValue: `${oldDescription}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.amount !== oldAmount) {
        auditInfo.push({
          setupArea: "Agency",
          actionTaken: "update",
          field: field,
          newValue: `${data.amount}`,
          oldValue: `${oldAmount}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.adjustmentDate !== oldAdjustmentDate) {
        auditInfo.push({
          setupArea: "Agency",
          actionTaken: "update",
          field: field,
          newValue: `${data.adjustmentDate}`,
          oldValue: `${oldAdjustmentDate}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.referenceId !== oldReferenceId) {
        auditInfo.push({
          setupArea: "Agency",
          actionTaken: "update",
          field: field,
          newValue: `${data.referenceId}`,
          oldValue: `${oldReferenceId}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      await SetAuditTrailBulk({ data: auditInfo });
      await fetchAdditionData();
      await fetchDeductionData();

      console.log("Data added successfully");
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset form fields
      setEmployeePersonalInformationId("");
      setPayrollPeriodId("");
      setPayTypeId("");
      setDescription("");
      setAmount("");
      setShowEditForm(false); // Hide the add form
      // fetchData(adjustmentType);
    } catch (error) {
      console.error("There was a problem adding data:", error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowEditForm(false);
  };
  const handleDelete = async () => {
    try {
      setLoadingRequest(true);
      await axios.delete(apiUrl + `${adjustmentType}/${deleteById}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      let field = "";

      if (adjustmentType === "OtherAdditionStaging") {
        field = "Other Addition";
      } else if (adjustmentType === "OtherDeductionStaging") {
        field = "Other Deduction";
      } else if (adjustmentType === "OtherAdjustmentStaging") {
        field = "Other Adjustment";
      }

      await SetAuditTrail({
        setupArea: "Subcon",
        actionTaken: "delete",
        field: field,
        newValue: `-`,
        oldValue: `${deleteData.employeePersonalInformationFullName}`,
        dateSaved: new Date(),
        savedById: user.id,
      });
      await fetchAdditionData();
      await fetchDeductionData();

      console.log("Deleted successfully");
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset state
      setShowDeleteForm(false);
      setDeleteById("");
      // fetchData(adjustmentType);
    } catch (error) {
      console.error("There was a problem deleting employee:", error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowDeleteForm(false);
  };
  const handleDeleteAll = async () => {
    if (!payrollIdForDelete) {
      alert("Please select payroll period id");
      return; // Exit early if fields are empty
    }

    try {
      setLoadingRequest(true);
      await axios.delete(
        apiUrl + `${adjustmentType}/payrollperiod/${payrollIdForDelete}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      let field = "";

      if (adjustmentType === "OtherAdditionStaging") {
        field = "Other Addition";
      } else if (adjustmentType === "OtherDeductionStaging") {
        field = "Other Deduction";
      } else if (adjustmentType === "OtherAdjustmentStaging") {
        field = "Other Adjustment";
      }

      await SetAuditTrail({
        setupArea: "Subcon",
        actionTaken: "delete all",
        field: field,
        newValue: `-`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id,
      });
      await fetchAdditionData();
      await fetchDeductionData();

      console.log("Deleted successfully");
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset state
      setShowDeleteAllForm(false);
      setPayrollIdForDelete("");
      // fetchData(adjustmentType);
    } catch (error) {
      console.error("There was a problem deleting employee:", error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowDeleteAllForm(false);
  };

  const addHandleClick = () => {
    setShowAddForm(true);
  };
  const editHandleClick = (data) => {
    setEditById(data.id);
    setDataToEdit(data);
    setShowEditForm(true);
  };
  const deleteHandleClick = (data) => {
    setShowDeleteForm(true);
    setDeleteById(data.id);
    setDeleteData(data);
  };
  const deleteAllHandleClick = (data) => {
    setShowDeleteAllForm(true);
  };
  const closeAddHandleClick = () => {
    setShowAddForm(false);
  };
  const closeEditHandleClick = () => {
    setShowEditForm(false);
  };
  const closeDeleteHandleClick = () => {
    setShowDeleteForm(false);
  };
  const closeDeleteAllHandleClick = () => {
    setShowDeleteAllForm(false);
  };
  const closeEmployeeForm = () => {
    setShowEmployeeForm(false);
  };
  const closeReferenceIdForm = () => {
    setReferenceIdForm(false);
  };

  return (
    <div>
      <div className="mainte-body-top row">
        {CreateSearchBarWithPlaceHolder(
          "",
          "mainte-search row",
          "mainte-search-icon",
          "mainte-search-input",
          (e) => handleFilter(e.target.value),
          "Search by name",
          SearchIcon
        )}
      </div>
      <div className="payroll-tab-header row">
        <div className="payroll-tab-leftSide row">
          <div className="leftSide-btn">
            <button
              id={activeButton === "btn-tab-addition" ? "btn-tab-active" : ""}
              onClick={() => {
                handleClick("btn-tab-addition");
                handleOtherFunction("btn-tab-addition");
              }}
            >
              OTHER ADDITIONS
            </button>
          </div>
          <div className="leftSide-btn">
            <button
              id={activeButton === "btn-tab-deductions" ? "btn-tab-active" : ""}
              onClick={() => {
                handleClick("btn-tab-deductions");
                handleOtherFunction("btn-tab-deductions");
              }}
            >
              OTHER DEDUCTIONS
            </button>
          </div>
          {/* <div className="leftSide-btn"><button id={activeButton === 'btn-tab-adjustments' ? 'btn-tab-active' : ''} onClick={() => { handleClick('btn-tab-adjustments'); handleOtherFunction('btn-tab-adjustments'); }}>ADJUSTMENTS</button></div> */}
        </div>
        <div className="payroll-tab-rightSide row">
          <div className="rightSide-btn">
            {CreateButton("", "add row", addHandleClick, "NEW", NoteAddIcon)}
          </div>
          <div className="rightSide-btn">
            {CreateButton(
              "",
              "delete row",
              deleteAllHandleClick,
              "DELETE ALL",
              DeleteSweepIcon
            )}
          </div>
        </div>
      </div>
      <div className="payroll-tables">
        <div
          id="addition-table"
          className="payroll-table container"
          style={{ display: "block" }}
        >
          <CreateTable
            dataList={otherAdditionData}
            dataHeader={adjustmentsHeader}
            dataAccessor={adjustmentsAccesor}
            editHandleClick={editHandleClick}
            deleteHandleClick={deleteHandleClick}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
          {otherAdditionData.length > 0 ? (
            <div></div>
          ) : (
            <div>
              {loadingOtherAddition ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "10vh",
                  }}
                >
                  <img src={loadingSpinner} alt="Loading..." />
                </div>
              ) : (
                <div> {/*<p>No records to display</p>*/}</div>
              )}
            </div>
          )}
        </div>
        <div id="deduction-table" className="payroll-table container">
          <CreateTable
            dataList={otherDeductionData}
            dataHeader={adjustmentsHeader}
            dataAccessor={adjustmentsAccesor}
            editHandleClick={editHandleClick}
            deleteHandleClick={deleteHandleClick}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
          {otherDeductionData.length > 0 ? (
            <div></div>
          ) : (
            <div>
              {loadingOtherDedujction ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "10vh",
                  }}
                >
                  <img src={loadingSpinner} alt="Loading..." />
                </div>
              ) : (
                <div> {/*<p>No records to display</p>*/}</div>
              )}
            </div>
          )}
        </div>
      </div>
      <AddForm
        isOpen={showAddForm}
        onClose={closeAddHandleClick}
        employeePersonalInformationId={employeePersonalInformationId}
        employeePersonalInformationFullName={
          employeePersonalInformationFullName
        }
        payrollPeriodId={payrollPeriodId}
        payTypeId={payTypeId}
        description={description}
        amount={amount}
        noOfHours={noOfHours}
        adjustmentDate={adjustmentDate}
        referenceId={referenceId}
        setEployeePersonalInformationId={setEmployeePersonalInformationId}
        setPayrollPeriodId={setPayrollPeriodId}
        setPayTypeId={setPayTypeId}
        setDescription={setDescription}
        setAmount={setAmount}
        setNoOfHours={setNoOfHours}
        setAdjustmentDate={setAdjustmentDate}
        setReferenceId={setReferenceId}
        setShowEmployeeForm={setShowEmployeeForm}
        setReferenceIdForm={setReferenceIdForm}
        adjustmentType={adjustmentType}
        handleSubmit={handleSubmit}
      ></AddForm>
      <EditForm
        isOpen={showEditForm}
        onClose={closeEditHandleClick}
        employeePersonalInformationId={employeePersonalInformationId}
        employeePersonalInformationFullName={
          employeePersonalInformationFullName
        }
        payrollPeriodId={payrollPeriodId}
        payTypeId={payTypeId}
        description={description}
        amount={amount}
        noOfHours={noOfHours}
        adjustmentDate={adjustmentDate}
        referenceId={referenceId}
        setEployeePersonalInformationId={setEmployeePersonalInformationId}
        setPayrollPeriodId={setPayrollPeriodId}
        setPayTypeId={setPayTypeId}
        setDescription={setDescription}
        setAmount={setAmount}
        setNoOfHours={setNoOfHours}
        setAdjustmentDate={setAdjustmentDate}
        setReferenceId={setReferenceId}
        setShowEmployeeForm={setShowEmployeeForm}
        setReferenceIdForm={setReferenceIdForm}
        adjustmentType={adjustmentType}
        handleUpdate={handleUpdate}
      ></EditForm>
      <DeleteForm
        isOpen={showDeleteForm}
        onClose={closeDeleteHandleClick}
        handleDelete={handleDelete}
      ></DeleteForm>
      <DeleteAllForm
        isOpen={showDeleteAllForm}
        onClose={closeDeleteAllHandleClick}
        payrollPeriodId={payrollIdForDelete}
        setPayrollPeriodId={setPayrollIdForDelete}
        handleDelete={handleDeleteAll}
      ></DeleteAllForm>
      <EmployeeSelectForm
        isOpen={showEmployeeForm}
        onClose={closeEmployeeForm}
        setEmployeeId={setEmployeePersonalInformationId}
        setEmployee={setEmployeePersonalInformationFullName}
        userAccessData={userAccess}
      ></EmployeeSelectForm>
      <ReferenceSelectForm
        isOpen={referenceIdForm}
        onClose={closeReferenceIdForm}
        setReferenceId={setReferenceId}
        setAdjustmentDate={setAdjustmentDate}
      ></ReferenceSelectForm>
      <GenerateMessage
        form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      ></GenerateMessage>
      {loadingRequest ? (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: "3005",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function SettingInit({
  generateDownloadTemplate,
  openUploadFormHandleClick,
  setSettingType,
}) {
  const handleUploadClick = (settingType) => {
    openUploadFormHandleClick();
    setSettingType(settingType);
  };
  return (
    <div id="payroll-setting" className="payroll-setting column">
      <div
        className="payroll-setting-item row"
        onClick={() => generateDownloadTemplate(false)}
      >
        <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}>
          <DownloadIcon />
        </div>
        Download Other Additions Template
      </div>
      <div
        className="payroll-setting-item row"
        onClick={() => generateDownloadTemplate(false)}
      >
        <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}>
          <DownloadIcon />
        </div>
        Download Other Deductions Template
      </div>
      <div
        className="payroll-setting-item row"
        onClick={() => generateDownloadTemplate(true)}
        style={{ display: "none" }}
      >
        <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}>
          <DownloadIcon />
        </div>
        Download Other Adjustments Template
      </div>
      <div
        className="payroll-setting-item row"
        onClick={() => handleUploadClick("Other Additions")}
      >
        <div style={{ margin: "10px 5px 0 5px", color: "#47d147" }}>
          <FileUploadIcon />
        </div>
        Upload Other Additions
      </div>
      <div
        className="payroll-setting-item row"
        onClick={() => handleUploadClick("Other Deductions")}
      >
        <div style={{ margin: "10px 5px 0 5px", color: "#47d147" }}>
          <FileUploadIcon />
        </div>
        Upload Other Deductions
      </div>
      <div
        className="payroll-setting-item row"
        onClick={() => handleUploadClick("Other Adjustments")}
        style={{ display: "none" }}
      >
        <div style={{ margin: "10px 5px 0 5px", color: "#47d147" }}>
          <FileUploadIcon />
        </div>
        Upload Other Adjustments
      </div>
    </div>
  );
}
function UploadForm({
  isOpen,
  onClose,
  payrollPeriodId,
  payTypeId,
  setPayrollPeriodId,
  setPayTypeId,
  type,
  handleFileUpload,
}) {
  const handleClose = () => {
    onClose();
    setPayrollPeriodId("");
    setPayTypeId("");
    setFiles("");
  };

  const [files, setFiles] = useState([]);

  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);
    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const fileList = Array.from(e.dataTransfer.files);
    setFiles(fileList);
    e.currentTarget.style.backgroundColor = "white";
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById("fileInput").value = "";
  };

  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (!payrollPeriodId || !payTypeId) {
      setErrorState(true);
      return;
    }
    handleFileUpload(files, type, payrollPeriodId, payTypeId);
    handleClose();
    setErrorState(false);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{"Upload " + type}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="popUp-item info-item column">
                <div className="info-item-label">Payroll Period</div>
                <div className="info-item-input">
                  <PayrollPeriodIdSelect
                    payrollPeriodId={payrollPeriodId}
                    setPayrollPeriodId={setPayrollPeriodId}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      !payrollPeriodId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Pay Type</div>
                <div className="info-item-input">
                  <PayTypeIdSelect
                    payTypeId={payTypeId}
                    setPayTypeId={setPayTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility: !payTypeId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
            </div>
            <div>
              <label htmlFor="fileInput" className="browse">
                Browse...
              </label>
              <input
                type="file"
                id="fileInput"
                onChange={(e) => handleBrowse(e)}
                style={{ display: "none" }}
              />
              <div
                id="drop-files-here"
                onDrop={(e) => handleDrop(e)}
                onDragOver={(e) => handleDragOver(e)}
                onDragLeave={(e) => handleDragOut(e)}
                style={{
                  border: "2px dashed #ccc",
                  borderRadius: "5px",
                  padding: "20px",
                  marginTop: "10px",
                  textAlign: "center",
                }}
              >
                Drop files here
              </div>
              {files.length > 0 && (
                <div style={{ border: "1px solid #97979745", padding: "10px" }}>
                  <span>Uploaded File:</span>
                  <ul>
                    {files.map((file, index) => (
                      <span key={index}>{file.name}</span>
                    ))}
                  </ul>
                  <div
                    className="buttons row"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <button
                      id="add-family"
                      className="cancel row"
                      onClick={() => clearFiles()}
                      style={{ marginRight: "5px" }}
                    >
                      CLEAR
                    </button>
                  </div>
                </div>
              )}
            </div>
            {files.length > 0 && (
              <div
                className="buttons row"
                style={{
                  justifyContent: "center",
                  padding: "40px 40px 20px 40px",
                }}
              >
                <button
                  id="add-family"
                  className="save row"
                  onClick={(e) => submit(e)}
                  style={{ marginRight: "5px" }}
                >
                  UPLOAD
                </button>
                <button
                  id="add-family"
                  className="cancel row"
                  onClick={() => handleClose()}
                >
                  CANCEL
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
function AddForm({
  isOpen,
  onClose,
  employeePersonalInformationId,
  employeePersonalInformationFullName,
  payrollPeriodId,
  payTypeId,
  description,
  amount,
  noOfHours,
  adjustmentDate,
  referenceId,
  setEployeePersonalInformationId,
  setPayrollPeriodId,
  setPayTypeId,
  setDescription,
  setAmount,
  setNoOfHours,
  setAdjustmentDate,
  setReferenceId,
  setShowEmployeeForm,
  setReferenceIdForm,
  adjustmentType,
  handleSubmit,
}) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (
      !employeePersonalInformationId ||
      !payrollPeriodId ||
      !payTypeId ||
      !description ||
      !amount
    ) {
      setErrorState(true);
      return;
    }
    handleSubmit(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setEployeePersonalInformationId("");
    setPayrollPeriodId("");
    setPayTypeId("");
    setDescription("");
    setAmount("");
    setAdjustmentDate("");
    setReferenceId("");
    setErrorState(false);
  };

  var formType = "";

  if (adjustmentType === "AgencyOtherAddition") {
    formType = "Add Other Addition Payroll";
  } else if (adjustmentType === "AgencyOtherDeduction") {
    formType = "Add Other Deduction Payroll";
  }

  var refValue = "";
  if (
    referenceId !== undefined &&
    referenceId !== null &&
    referenceId !== "" &&
    referenceId !== 0
  ) {
    const value = referenceId;
    const formattedNumber = value.toString().padStart(6, "0");
    refValue = `LV-${formattedNumber}`;
  }

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{formType}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <div
                    className="info-item-holder employee-select row"
                    style={{ flexDirection: "row", justifyContent: "normal" }}
                  >
                    <input
                      readOnly
                      className="employeeInput-select"
                      placeholder="Employee"
                      value={
                        employeePersonalInformationId
                          ? employeePersonalInformationFullName
                          : employeePersonalInformationId
                      }
                    />
                    <button
                      className="select row"
                      onClick={() => setShowEmployeeForm(true)}
                    >
                      <SearchIcon />
                    </button>
                  </div>
                  <span
                    style={{
                      visibility:
                        !employeePersonalInformationId && errorState
                          ? "visible"
                          : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Payroll Period</div>
                <div className="info-item-input">
                  <PayrollPeriodIdSelect
                    payrollPeriodId={payrollPeriodId}
                    setPayrollPeriodId={setPayrollPeriodId}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      !payrollPeriodId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Pay Type</div>
                <div className="info-item-input">
                  <PayTypeIdSelect
                    payTypeId={payTypeId}
                    setPayTypeId={setPayTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility: !payTypeId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Description</div>
                <div className="info-item-input">
                  <input
                    placeholder="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      !description && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Amount</div>
                <div className="info-item-input">
                  <input
                    type="number"
                    placeholder="Amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </div>
                <span
                  style={{
                    visibility: !amount && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              {adjustmentType === "OtherAdjustmentStaging" ? (
                <div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Number of Hours</div>
                    <div className="info-item-input">
                      <input
                        type="number"
                        placeholder="Number of Hours"
                        value={noOfHours}
                        onChange={(e) => setNoOfHours(e.target.value)}
                      />
                    </div>
                    <span
                      style={{
                        visibility:
                          !noOfHours && errorState ? "visible" : "hidden",
                        color: "#ff6565",
                        fontSize: "12px",
                      }}
                    >
                      Please fill up this field
                    </span>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Adjustment Date</div>
                    <div className="info-item-input">
                      <DateTimeInput
                        date={adjustmentDate}
                        setDate={setAdjustmentDate}
                      />
                    </div>
                    <span
                      style={{
                        visibility:
                          !adjustmentDate && errorState ? "visible" : "hidden",
                        color: "#ff6565",
                        fontSize: "12px",
                      }}
                    >
                      Please fill up this field
                    </span>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Reference Id</div>
                    <div className="info-item-input">
                      <div
                        className="info-item-holder employee-select row"
                        style={{
                          flexDirection: "row",
                          justifyContent: "normal",
                        }}
                      >
                        <input
                          readOnly
                          className="employeeInput-select"
                          placeholder="Reference Id"
                          value={refValue}
                        />
                        <button
                          className="select row"
                          onClick={() => setReferenceIdForm(true)}
                        >
                          <SearchIcon />
                        </button>
                      </div>
                      <span
                        style={{
                          visibility:
                            !referenceId && errorState ? "visible" : "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up this field
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
              >
                SAVE
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EditForm({
  isOpen,
  onClose,
  employeePersonalInformationId,
  employeePersonalInformationFullName,
  payrollPeriodId,
  payTypeId,
  description,
  amount,
  noOfHours,
  adjustmentDate,
  referenceId,
  setEployeePersonalInformationId,
  setPayrollPeriodId,
  setPayTypeId,
  setDescription,
  setAmount,
  setAdjustmentDate,
  setReferenceId,
  setShowEmployeeForm,
  setNoOfHours,
  setReferenceIdForm,
  adjustmentType,
  handleUpdate,
}) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (
      !employeePersonalInformationId ||
      !payrollPeriodId ||
      !payTypeId ||
      !description ||
      !amount
    ) {
      if (adjustmentType === "OtherAdjustmentStaging") {
        if (!adjustmentDate && !referenceId && !noOfHours) {
          setErrorState(true);
          return;
        }
      }
      setErrorState(true);
      return;
    }
    handleUpdate(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setEployeePersonalInformationId("");
    setPayrollPeriodId("");
    setPayTypeId("");
    setDescription("");
    setAmount("");
    setAdjustmentDate("");
    setReferenceId("");
    setErrorState(false);
  };

  var formType = "";

  if (adjustmentType === "OtherAddition") {
    formType = "Update Other Addition Payroll";
  } else if (adjustmentType === "OtherDeduction") {
    formType = "Update Other Deduction Payroll";
  } else if (adjustmentType === "OtherAdjustment") {
    formType = "Update Other Adjustment Payroll";
  }

  var refValue = "";
  if (
    referenceId !== undefined &&
    referenceId !== null &&
    referenceId !== "" &&
    referenceId !== 0
  ) {
    const value = referenceId;
    const formattedNumber = value.toString().padStart(6, "0");
    refValue = `LV-${formattedNumber}`;
  }

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{formType}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <div
                    className="info-item-holder employee-select row"
                    style={{ flexDirection: "row", justifyContent: "normal" }}
                  >
                    <input
                      readOnly
                      className="employeeInput-select"
                      placeholder="Employee"
                      style={{ cursor: "not-allowed" }}
                      value={
                        employeePersonalInformationId
                          ? employeePersonalInformationFullName
                          : employeePersonalInformationId
                      }
                    />
                  </div>
                </div>
                <span
                  style={{
                    visibility:
                      !employeePersonalInformationId && errorState
                        ? "visible"
                        : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Payroll Period</div>
                <div className="info-item-input">
                  <PayrollPeriodIdSelect
                    payrollPeriodId={payrollPeriodId}
                    setPayrollPeriodId={setPayrollPeriodId}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      !payrollPeriodId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Pay Type</div>
                <div className="info-item-input">
                  <PayTypeIdSelect
                    payTypeId={payTypeId}
                    setPayTypeId={setPayTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility: !payTypeId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Description</div>
                <div className="info-item-input">
                  <input
                    placeholder="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      !description && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Amount</div>
                <div className="info-item-input">
                  <input
                    type="number"
                    placeholder="Amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </div>
                <span
                  style={{
                    visibility: !amount && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              {adjustmentType === "OtherAdjustmentStaging" ? (
                <div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Number of Hours</div>
                    <div className="info-item-input">
                      <input
                        type="number"
                        placeholder="Number of Hours"
                        value={noOfHours}
                        onChange={(e) => setNoOfHours(e.target.value)}
                      />
                    </div>
                    <span
                      style={{
                        visibility:
                          !noOfHours && errorState ? "visible" : "hidden",
                        color: "#ff6565",
                        fontSize: "12px",
                      }}
                    >
                      Please fill up this field
                    </span>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Adjustment Date</div>
                    <div className="info-item-input">
                      <DateTimeInput
                        date={adjustmentDate}
                        setDate={setAdjustmentDate}
                      />
                    </div>
                    <span
                      style={{
                        visibility:
                          !adjustmentDate && errorState ? "visible" : "hidden",
                        color: "#ff6565",
                        fontSize: "12px",
                      }}
                    >
                      Please fill up this field
                    </span>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Reference Id</div>
                    <div className="info-item-input">
                      <div
                        className="info-item-holder employee-select row"
                        style={{
                          flexDirection: "row",
                          justifyContent: "normal",
                        }}
                      >
                        <input
                          readOnly
                          className="employeeInput-select"
                          placeholder="Reference Id"
                          value={refValue}
                        />
                        <button
                          className="select row"
                          onClick={() => setReferenceIdForm(true)}
                        >
                          <SearchIcon />
                        </button>
                      </div>
                      <span
                        style={{
                          visibility:
                            !referenceId && errorState ? "visible" : "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up this field
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
              >
                UPDATE
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function DeleteForm({ isOpen, onClose, handleDelete }) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Delete!</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span>Are you sure you want to delete this?</span>
            </div>
            <div
              className="buttons row"
              style={{
                justifyContent: "center",
                padding: "40px 40px 20px 40px",
              }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleDelete}
                style={{ marginRight: "5px" }}
              >
                DELETE
              </button>
              <button
                id="add-family"
                className="cancel row"
                onClick={() => handleClose()}
              >
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function DeleteAllForm({
  isOpen,
  onClose,
  payrollPeriodId,
  setPayrollPeriodId,
  handleDelete,
}) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (!payrollPeriodId) {
      setErrorState(true);
      return;
    }
    handleClose();
    handleDelete(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setPayrollPeriodId("");
    setErrorState(false);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Delete!</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="popUp-item info-item column">
                <div className="info-item-label">Payroll Period</div>
                <div className="info-item-input">
                  <PayrollPeriodIdSelect
                    payrollPeriodId={payrollPeriodId}
                    setPayrollPeriodId={setPayrollPeriodId}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      !payrollPeriodId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
            </div>
            <div
              className="buttons row"
              style={{
                justifyContent: "center",
                padding: "40px 40px 20px 40px",
              }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
                style={{ marginRight: "5px" }}
              >
                DELETE
              </button>
              <button
                id="add-family"
                className="cancel row"
                onClick={() => handleClose()}
              >
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function PayrollPeriodIdSelect({ payrollPeriodId, setPayrollPeriodId }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setPayrollPeriodId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    //const currentYear = new Date().getFullYear();
    //const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
    const apiUrl = domain + `/api/PayrollPeriod/active`; // changed

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchData();
    if (payrollPeriodId !== "" && payrollPeriodId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [payrollPeriodId]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        value={payrollPeriodId}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose payroll period
        </option>
        {data.map((payrollPeriodId) => SetPayrollPeriodId(payrollPeriodId))}
      </select>
    </div>
  );
}
function SetPayrollPeriodId(payrollPeriodId) {
  const formattedDateFrom = format(payrollPeriodId.dateFrom, "MM/dd/yyyy");
  const formattedDateTo = format(payrollPeriodId.dateTo, "MM/dd/yyyy");

  return (
    <option value={payrollPeriodId.id}>
      {`${formattedDateFrom} - ${formattedDateTo} ${
        payrollPeriodId.payTypeDescription
          ? payrollPeriodId.payTypeDescription
          : ""
      }`}
    </option>
  );
}
function PayTypeIdSelect({ payTypeId, setPayTypeId }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setPayTypeId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/PayType/active";

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setData(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchData();
    if (payTypeId !== "" && payTypeId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [payTypeId]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        value={payTypeId}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose pay type
        </option>
        {data.map((payTypeId) => SetPayTypeId(payTypeId))}
      </select>
    </div>
  );
}
function SetPayTypeId(payTypeId) {
  return <option value={payTypeId.id}>{payTypeId.description}</option>;
}
function ClassificationIdSelectWithAllDummy() {
  return (
    <div>
      <select id="employee-select-PagibigReport"></select>
    </div>
  );
}
function ClassificationIdSelectWithAll1({
  classificationId,
  setClassificationId,
}) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setClassificationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Classification/active";

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setData(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchData();
    if (classificationId !== "" && classificationId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [classificationId]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        value={classificationId}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose classification
        </option>
        {data.length > 0 && <option value="All">All</option>}
        {data.map((classificationId) => SetClassificationId(classificationId))}
      </select>
    </div>
  );
}
function ClassificationIdSelectWithAll2({
  classificationId,
  setClassificationId,
}) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setClassificationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Classification/active";

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setData(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchData();
    if (classificationId !== "" && classificationId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [classificationId]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        value={classificationId}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        {data.map((classificationId) => (
          <React.Fragment key={classificationId.id}>
            {classificationId.id === 2 && SetClassificationId(classificationId)}
            {classificationId.id === 3 && SetClassificationId(classificationId)}
          </React.Fragment>
        ))}
      </select>
    </div>
  );
}
function ClassificationIdSelectWithAll3({
  classificationId,
  setClassificationId,
}) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setClassificationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Classification/active";

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setData(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchData();
    if (classificationId !== "" && classificationId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [classificationId]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        value={classificationId}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        {data.map((classificationId) => (
          <React.Fragment key={classificationId.id}>
            {classificationId.id === 4 && SetClassificationId(classificationId)}
          </React.Fragment>
        ))}
      </select>
    </div>
  );
}
function SetClassificationId(classificationId) {
  return (
    <option value={classificationId.id}>{classificationId.description}</option>
  );
}
function DateTimeInput({ date, setDate }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleDateTimeChange = (event) => {
    setDate(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if (date !== undefined && date !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [date]);

  let formattedDate = "";

  if (date) {
    formattedDate = date.split("T")[0];
  }

  return (
    <div>
      <input
        type="date"
        id={"datetime-"}
        name="datetime"
        value={formattedDate} // Exclude milliseconds
        onChange={handleDateTimeChange}
        style={{
          width: "90%",
          height: "30px",
          borderRadius: "3px",
          border: "1px solid #80808080",
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
          fontFamily:
            "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
        }}
      />
    </div>
  );
}
function EmployeeSelectForm({
  isOpen,
  onClose,
  setEmployeeId,
  setEmployee,
  userAccessData,
}) {
  var header = ["Id", "Name"];
  var accessor = ["employeeId", "fullName"];

  const handleClose = () => {
    onClose();
    fetchData();
  };
  const handleProceed = () => {
    onClose();
    setEmployeeId(selectedEmployee.id);
    setEmployee(selectedEmployee.fullName);
    fetchData();
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [employeesInfo, setEmployeesInfo] = useState([]);
  const [allEmployeesBasicInfo, setAllEmployeesBasicInfo] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

  const [
    classificationFilterForAdminHRHead,
    setClassificationFilterForAdminHRHead,
  ] = useState("0");
  const [classificationFilterForHRAsst2, setClassificationFilterForHRAsst2] =
    useState("2");
  const [classificationFilterForHRAsst3, setClassificationFilterForHRAsst3] =
    useState("4");
  const [currentClassificationFilter, setCurrentClassificationFilter] =
    useState("");

  /* const fetchDataAllData = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee";
        try {
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []); */

  const fetchData = useCallback(async () => {
    const apiUrl = domain + "/api/Employee/active";

    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });
      // const employeeAllData = await fetchDataAllData();
      setEmployeesInfo(response.data);
      setAllEmployeesBasicInfo(response.data);
      setEmployees(response.data);
      setFilterData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, []);

  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.employeeId.toString().startsWith(lowercaseValue)
        );
        break;
      default:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );

        break;
    }

    setEmployees(res);
  };

  useEffect(() => {
    let classifiedData = allEmployeesBasicInfo;
    let classificiationFilter = classificationFilterForAdminHRHead;

    if (userAccessData) {
      if (
        userAccessData.description === "Admin" ||
        userAccessData.description === "HR Head" ||
        userAccessData.description === "HR Assistant" ||
        userAccessData.description === "Accounting" ||
        userAccessData.description === "Accounting Head" ||
        userAccessData.description === "Accounting Assistant"
      ) {
        classificiationFilter = classificationFilterForAdminHRHead;
      } else if (userAccessData.description === "HR Assistant2") {
        classificiationFilter = classificationFilterForHRAsst2;
      } else if (userAccessData.description === "HR Assistant3") {
        classificiationFilter = classificationFilterForHRAsst3;
      }
    }

    setCurrentClassificationFilter(classificiationFilter);

    if (classificiationFilter !== "0" && classificiationFilter !== "All") {
      const _classified = allEmployeesBasicInfo.filter((employee) => {
        const foundEmployee = employeesInfo.find(
          (_employee) => _employee.employeeId === employee.employeeId
        );

        if (
          foundEmployee.employeeInformation &&
          foundEmployee.employeeInformation.classificationId
        ) {
          return (
            foundEmployee.employeeInformation.classificationId.toString() ===
            classificiationFilter
          );
        }
        return false;
      });

      classifiedData = _classified;
    }

    if (classificiationFilter !== currentClassificationFilter) {
      setEmployees(classifiedData);
      setFilterData(classifiedData);
    }
  }, [
    classificationFilterForAdminHRHead,
    classificationFilterForHRAsst2,
    classificationFilterForHRAsst3,
    currentClassificationFilter,
    employees,
    employeesInfo,
    allEmployeesBasicInfo,
    userAccessData,
  ]);

  useEffect(() => {
    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("Search by name");
        break;
      case 1:
        setSearchPlaceholder("Search by id");
        break;
      default:
        setSearchPlaceholder("Search by name");
        break;
    }
    fetchData();
  }, [fetchData, filterDataIndex]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Employee</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="transaction-body">
                <div className="filters-payroll">
                  <span>Filter</span>
                  <div
                    className="payroll-item-holder info-item-holder row"
                    style={{
                      padding: "0 10px 20px 10px",
                      justifyContent: "normal",
                    }}
                  >
                    <div className="filter-item-payroll popUp-item info-item column">
                      <div className="info-item-label">Filter</div>
                      <div className="info-item-input">
                        <EmployeeFilter
                          setFilterDataIndex={setFilterDataIndex}
                        />
                      </div>
                    </div>
                    {userAccessData.length <= 0 && (
                      <div className="filter-item-payroll popUp-item info-item column">
                        <div className="info-item-label">
                          Classification Type
                        </div>
                        <div className="info-item-input">
                          <ClassificationIdSelectWithAllDummy />
                        </div>
                      </div>
                    )}
                    {userAccessData &&
                      (userAccessData.description === "Admin" ||
                        userAccessData.description === "HR Head" ||
                        userAccessData.description === "HR Assistant" ||
                        userAccessData.description === "Accounting" ||
                        userAccessData.description === "Accounting Head" ||
                        userAccessData.description ===
                          "Accounting Assistant") && (
                        <div className="filter-item-payroll popUp-item info-item column">
                          <div className="info-item-label">
                            Classification Type
                          </div>
                          <div className="info-item-input">
                            <ClassificationIdSelectWithAll1
                              classificationId={
                                classificationFilterForAdminHRHead
                              }
                              setClassificationId={
                                setClassificationFilterForAdminHRHead
                              }
                            />
                          </div>
                        </div>
                      )}
                    {userAccessData &&
                      userAccessData.description === "HR Assistant2" && (
                        <div className="filter-item-payroll popUp-item info-item column">
                          <div className="info-item-label">
                            Classification Type
                          </div>
                          <div className="info-item-input">
                            <ClassificationIdSelectWithAll2
                              classificationId={classificationFilterForHRAsst2}
                              setClassificationId={
                                setClassificationFilterForHRAsst2
                              }
                            />
                          </div>
                        </div>
                      )}
                    {userAccessData &&
                      userAccessData.description === "HR Assistant3" && (
                        <div className="filter-item-payroll popUp-item info-item column">
                          <div className="info-item-label">
                            Classification Type
                          </div>
                          <div className="info-item-input">
                            <ClassificationIdSelectWithAll3
                              classificationId={classificationFilterForHRAsst3}
                              setClassificationId={
                                setClassificationFilterForHRAsst3
                              }
                            />
                          </div>
                        </div>
                      )}
                  </div>
                </div>
                <div className="transaction-body-top row">
                  {CreateSearchBarWithPlaceHolder(
                    "",
                    "transaction-search row",
                    "transaction-search-icon",
                    "transaction-search-input",
                    (e) => handleFilter(e.target.value),
                    searchPlaceholder,
                    SearchIcon
                  )}
                </div>
              </div>
              <div className="select-employee-table">
                <CreateTableForEmployeeSelect
                  dataList={employees}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedEmployee={setSelectedEmployee}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
                {employees.length > 0 ? (
                  <div></div>
                ) : (
                  <div>
                    {loading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "10vh",
                        }}
                      >
                        <img src={loadingSpinner} alt="Loading..." />
                      </div>
                    ) : (
                      <div> {/*<p>No records to display</p>*/}</div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EmployeeFilter({ setFilterDataIndex }) {
  const [selectedOption, setSelectedOption] = useState("All");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "EmployeeId":
        setFilterDataIndex(1);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <select
      id=""
      className="filterSelect"
      value={selectedOption}
      onChange={handleSelectChange}
    >
      <option value="All">All</option>
      <option value="EmployeeId">Employee Id</option>
    </select>
  );
}
function ReferenceSelectForm({
  isOpen,
  onClose,
  setReferenceId,
  setAdjustmentDate,
}) {
  var header = [
    "Reference No.",
    "Employee",
    "Request Date",
    "Request",
    "Status",
    "",
  ];
  var accessor = [
    "referenceNumber",
    "employeePersonalInformationFullName",
    "dateRequested",
    "requestTypeDescription",
    "status",
    "manage",
  ];

  const [viewData, setViewData] = useState([]);
  const [showViewData, setShowViewData] = useState(false);
  const [reference, setReference] = useState([]);
  const [selectedReference, setSelectedReference] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState(
    "Search by reference id"
  );

  const handleClose = () => {
    onClose();
    fetchData();
  };
  const handleProceed = () => {
    onClose();
    if (selectedReference.length !== 0) {
      setReferenceId(selectedReference.referenceNumber);
      setAdjustmentDate(selectedReference.dateRequested);
    }
    fetchData();
  };
  const viewHandleClick = (data) => {
    setViewData(data);
    setShowViewData(true);
  };
  const closeViewHandleClick = () => {
    setShowViewData(false);
  };

  const fetchData = async () => {
    const apiUrl = domain + "/api/LeaveRequest";

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        const filteredDatas = response.data.filter(
          (filteredData) => filteredData.status === "Approved"
        );
        setReference(filteredDatas); // Set the response data to the state
        setFilterData(filteredDatas); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const handleFilter = (value) => {
    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.referenceNumber.toString().startsWith(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.employeePersonalInformationFullName
            .toLowerCase()
            .includes(lowercaseValue)
        );
        break;
      default:
        res = filterData.filter((f) =>
          f.referenceNumber.toString().startsWith(lowercaseValue)
        );
        break;
    }

    setReference(res);
  };

  useEffect(() => {
    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("Search by reference id");
        break;
      case 1:
        setSearchPlaceholder("Search by employee");
        break;
      default:
        setSearchPlaceholder("Search by reference id");
        break;
    }
    fetchData();
  }, [filterDataIndex]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Reference Id</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="transaction-body">
              <ReferenceFilter setFilterDataIndex={setFilterDataIndex} />
              <div className="transaction-body-top row">
                {CreateSearchBarWithPlaceHolder(
                  "",
                  "transaction-search row",
                  "transaction-search-icon",
                  "transaction-search-input",
                  (e) => handleFilter(e.target.value),
                  searchPlaceholder,
                  SearchIcon
                )}
              </div>
            </div>
            <div className="popUp-body selectModal">
              <div className="select-employee-table">
                <CreateTableForReferenceSelect
                  dataList={reference}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedReference={setSelectedReference}
                  viewHandleClick={viewHandleClick}
                />
                {reference.length > 0 ? (
                  <div></div>
                ) : (
                  <div> {/*<p>No records to display</p>*/}</div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
      <ViewLeaveForm
        isOpen={showViewData}
        onClose={closeViewHandleClick}
        viewData={viewData}
      ></ViewLeaveForm>
    </>
  );
}
function ReferenceFilter({ setFilterDataIndex }) {
  const [selectedOption, setSelectedOption] = useState("All");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "Employee":
        setFilterDataIndex(1);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <div className="filters row" style={{ alignItems: "center" }}>
      <span style={{ marginRight: "10px" }}>Filter</span>
      <select
        id=""
        className="filterSelect"
        value={selectedOption}
        onChange={handleSelectChange}
      >
        <option value="All">All</option>
        <option value="Employee">Employee</option>
      </select>
    </div>
  );
}
function ViewLeaveForm({ isOpen, onClose, viewData }) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Reference Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullNameLeave"
                    placeholder="Employee"
                    value={viewData.employeePersonalInformationFullName}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Leave Type</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullNameLeave"
                    placeholder="Employee"
                    value={viewData.leaveTypeDescription}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date From</div>
                  <div className="info-item-input">
                    <input
                      readOnly={true}
                      id="employeePersonalInformationFullNameLeave"
                      placeholder="Employee"
                      value={viewData.dateFrom}
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date To</div>
                  <div className="info-item-input">
                    <input
                      readOnly={true}
                      id="employeePersonalInformationFullNameLeave"
                      placeholder="Employee"
                      value={viewData.dateTo}
                    />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Days</div>
                  <div className="info-item-input">
                    <input
                      readOnly
                      type="number"
                      id="daysLeave"
                      placeholder="Days"
                      value={viewData.days}
                    />
                  </div>
                </div>
              </div>
              <div className="transaction-from-splitItem row">
                <div className="transaction-form-item row">
                  <div
                    className="transaction-form-input"
                    style={{ width: "auto" }}
                  >
                    <input
                      type="checkbox"
                      readOnly
                      id="overtime-allowance"
                      className="checkbox"
                      name=""
                      checked={viewData.isHalfDay}
                    />
                  </div>
                  <div
                    className="transaction-form-category"
                    style={{ padding: "0 10px" }}
                  >
                    <h5 style={{ fontWeight: "normal" }}>Half Day?</h5>
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={viewData.reason}
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="cancel row"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function GenerateMessage({ form, message, isSuccess }) {
  return (
    <>
      <div
        className={`modal-overlay toggleMessage-overlay ${form ? "open" : ""}`}
      >
        {form && (
          <div
            className="modal toggleMessage"
            style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}
          >
            <div className="column">
              {isSuccess ? (
                <div
                  className="request_title row"
                  style={{
                    fontWeight: "bold",
                    color: "green",
                    alignItems: "center",
                  }}
                >
                  <CheckCircleIcon />
                  <span>{"SUCCESS MESSAGE"}</span>
                </div>
              ) : (
                <div
                  className="request_title row"
                  style={{
                    fontWeight: "bold",
                    color: "#DD5746",
                    alignItems: "center",
                  }}
                >
                  <ErrorIcon />
                  <span>{"ERROR MESSAGE"}</span>
                </div>
              )}
              <span
                style={{
                  textAlign: "center",
                  padding: "10px 0",
                  color: isSuccess ? "green" : "#DD5746",
                }}
              >
                {message}
              </span>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
export function CreateTableForReferenceSelect({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  viewHandleClick,
  setSelectedReference,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [activeRowId, setActiveRowId] = useState(null);
  const itemsPerPage = 10;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: dataList });

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleRowClick = (rowData) => {
    setSelectedReference(rowData); // Pass the clicked row data to the setSelectedEmployee function
    setActiveRowId(rowData.id);
  };

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 && (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr
                key={row.original.id}
                {...row.getRowProps()}
                onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                className={row.original.id === activeRowId ? "active" : ""}
              >
                {row.cells.map((cell) =>
                  SetInfo(
                    cell.render("Cell").props.column.Header,
                    cell,
                    viewHandleClick
                  )
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <div>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
                height: "26px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          <div
            style={{ textAlign: "center" }}
          >{`${currentPage}/${totalPages}`}</div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function SetInfo(header, _cell, viewHandleClick, deleteHandleClick) {
  const data = _cell.render("Cell").props.row.original;

  if (header === "") {
    return (
      <td>
        <div
          className="row"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <Tooltip text="View">
            <div
              style={{ padding: "0 5px" }}
              onClick={() => viewHandleClick(data)}
            >
              <RemoveRedEyeIcon />
            </div>
          </Tooltip>
          {deleteHandleClick ? (
            <Tooltip text="Delete">
              <div
                style={{ padding: "0 5px" }}
                onClick={() => deleteHandleClick(data)}
              >
                <DeleteForeverIcon />
              </div>
            </Tooltip>
          ) : (
            <></>
          )}
        </div>
      </td>
    );
  }

  if (header === "Reference No.") {
    const value = _cell.render("Cell").props.value;

    const formattedNumber = value.toString().padStart(6, "0");

    if (data.requestTypeId === 1) {
      return <td>LV-{formattedNumber}</td>;
    } else if (data.requestTypeId === 2) {
      return <td>CS-{formattedNumber}</td>;
    } else if (data.requestTypeId === 3) {
      return <td>OT-{formattedNumber}</td>;
    } else if (data.requestTypeId === 4) {
      return <td>CH-{formattedNumber}</td>;
    } else if (data.requestTypeId === 5) {
      return <td>OS-{formattedNumber}</td>;
    }
  }

  if (header === "Request Date") {
    const date = new Date(_cell.render("Cell").props.value);

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return <td>{formattedDateFrom}</td>;
  }

  return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}
const Tooltip = ({ text, children }) => {
  const [show, setShow] = useState(false);

  const handleMouseEnter = () => {
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  return (
    <div style={{ position: "relative", display: "inline-block", zIndex: "1" }}>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {children}
      </div>
      {show && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "-50%",
            transform: "translateX(-50%)",
            backgroundColor: "white",
            color: "gray",
            padding: "5px",
            borderRadius: "5px",
            pointerEvents: "none",
            boxShadow:
              "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};
export default Agency;
